import { notification } from 'antd'
import { publicAPI, privateAPI, attachToken } from '../../Config/Constant'
import store from '../store'


export const getConversations = async (payload) => {
  try {
    const res = await publicAPI.get(`/conversation/list/${payload.organizationid}`)
    if (res) {
      store.dispatch({
        type: 'SET_ALL_CONVERSATIONS',
        payload: res.data?.data?.conversations || [],
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const getCampaignConversations = async (payload) => {
  try {
    const res = await publicAPI.get(`/conversation/campaign/${payload.campaignid}`)
    if (res) {
      store.dispatch({
        type: 'SET_CAMPAIGN_CONVERSATIONS',
        payload: res.data?.data?.conversations || [],
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const getConversationMessages = async (payload) => {
  try {
    const res = await publicAPI.get(`/conversation/${payload.conversationid}/messages`)
    if (res) {
      store.dispatch({
        type: 'SET_CONVERSATION_MESSAGES',
        payload: res.data?.data?.messages || [],
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const getConversation = async (payload) => {
  try {
    const res = await publicAPI.get(`/conversation/${payload.conversationid}`)
    if (res) {
      store.dispatch({
        type: 'SET_CURRENT_CONVERSATION',
        payload: res.data?.data?.conversation || null,
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const updateConversationStatus = async (payload) => {
  try {
    await attachToken()
    const res = await privateAPI.put(`/conversation/${payload.conversationid}/status`, {
      status: payload.status,
    })
    if (res) {
      notification.success({
        description: res.data?.data?.message || 'Status updated successfully',
        duration: 2,
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const getConversationStats = async (payload) => {
  try {
    const res = await publicAPI.get(`/conversation/stats/${payload.organizationid}`)
    if (res) {
      store.dispatch({
        type: 'SET_CONVERSATION_STATS',
        payload: res.data?.data?.stats || null,
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const saveAIConfig = async (payload) => {
  try {
    await attachToken()
    const res = await privateAPI.post(`/conversation/ai-config/${payload.campaignid}`, payload.config)
    if (res) {
      notification.success({
        description: res.data?.data?.message || 'AI configuration saved successfully',
        duration: 2,
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}

export const getAIConfig = async (payload) => {
  try {
    const res = await publicAPI.get(`/conversation/ai-config/${payload.campaignid}`)
    if (res) {
      store.dispatch({
        type: 'SET_AI_CONFIG',
        payload: res.data?.data?.aiConfig || null,
      })
      return res
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
  }
}
